import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from "@angular/core";
import { MatSnackBar} from '@angular/material/snack-bar';
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class PCodeServices
{
    _urlParts: string[];
    _area?: string;
    _controller?: string;
    _httpOptions: {};

    // constructor
	constructor(
		@Inject('BASE_URL') private baseUrl: string,
        private _http: HttpClient,
        private translateService: TranslateService,
        private router: Router,
		private _snackBar: MatSnackBar
	)
    {

    }

    // notify
    // ====================================================================================
    public notify(type: string, message?: string)
    {
		this._snackBar.open(message, this.translateService.instant('Commons.Actions.Close'), {
			panelClass: [`snackbar--${type}`]
		});
    }
}